import { useEffect, useState } from "react";
import {
  Link,
  useNavigate,
  useSearchParams,
} from "react-router-dom";

import {
  createUserWithEmailAndPassword,
  deleteUser,
} from "firebase/auth";

import {
  collection,
  doc,
  getDocs,
  getDoc,
  query,
  serverTimestamp,
  setDoc,
  where,
  
} from "firebase/firestore";
import { auth, db } from "../firebase";
import "../App.css";

function Signup() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const [name, setName] = useState("");
  const [mobile, setMobile] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [referralCode, setReferralCode] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const refFromLink = searchParams.get("ref");

    if (refFromLink) {
      setReferralCode(refFromLink.trim().toUpperCase());
    }
  }, [searchParams]);

  const signupUser = async (event) => {
    event.preventDefault();

    if (loading) {
      return;
    }

    const cleanName = name.trim();
    const cleanMobile = mobile.trim();
    const cleanEmail = email.trim().toLowerCase();
    const cleanReferralCode = referralCode.trim().toUpperCase();

    if (
      !cleanName ||
      !cleanMobile ||
      !cleanEmail ||
      !password ||
      !confirmPassword
    ) {
      alert("Please fill all required fields.");
      return;
    }

    const mobileDigits = cleanMobile.replace(/\D/g, "");

    if (mobileDigits.length < 10 || mobileDigits.length > 15) {
      alert("Please enter a valid mobile number.");
      return;
    }

    if (password.length < 6) {
      alert("Password must be at least 6 characters.");
      return;
    }

    if (password !== confirmPassword) {
      alert("Password and confirm password do not match.");
      return;
    }

    let createdUser = null;

    try {
      setLoading(true);

      let referrerUid = "";
      let validReferralCode = "";
      console.log("cleanReferralCode =", cleanReferralCode);
// Referral code verify
if (cleanReferralCode) {
  const referralRef = doc(db, "referrals", cleanReferralCode);
  const referralSnap = await getDoc(referralRef);

  if (!referralSnap.exists()) {
    alert("Invalid referral code.");
    return;
  }

  referrerUid = referralSnap.data().uid;
  validReferralCode = cleanReferralCode;
}
console.log("Before Auth");
console.log(auth.currentUser);

const userCredential =
  await createUserWithEmailAndPassword(
    auth,
    cleanEmail,
    password
  );

console.log("After Auth");
console.log(userCredential.user);

createdUser = userCredential.user;

      const generatedReferralCode =
        `ST${createdUser.uid.slice(0, 6).toUpperCase()}`;

console.log("Saving user...");
      await setDoc(doc(db, "users", createdUser.uid), {
        uid: createdUser.uid,
        name: cleanName,
        mobile: cleanMobile,
        email: cleanEmail,

        referralCode: generatedReferralCode,
        referredBy: validReferralCode,
        referredByUid: referrerUid,

        balance: 0.4,
        signupBonus: 0.4,

        totalDeposit: 0,
        totalProfit: 0,
        totalWithdraw: 0,
        referralCommission: 0,

        createdAt: serverTimestamp(),
      });
      console.log("User saved successfully");
     console.log("Saving referral...");
await setDoc(
  doc(db, "referrals", generatedReferralCode),
  {
    uid: createdUser.uid,
  }
);
console.log("Referral saved successfully");


      alert("Account created successfully!");
      navigate("/dashboard", { replace: true });
    } catch (error) {
    console.log(error.code);
console.log(error.message);
console.log(error);
      alert(error.code + " : " + error.message);

      // Firestore save fail ho to adhoora Auth account delete karo
      if (
        createdUser &&
        error.code !== "auth/email-already-in-use"
      ) {
        try {
          await deleteUser(createdUser);
        } catch (deleteError) {
          console.error(
            "Incomplete account delete error:",
            deleteError
          );
        }
      }

      if (error.code === "auth/email-already-in-use") {
        alert("This email is already registered.");
      } else if (error.code === "auth/invalid-email") {
        alert("Please enter a valid email address.");
      } else if (error.code === "auth/weak-password") {
        alert("Password must be at least 6 characters.");
      } else if (error.code === "auth/network-request-failed") {
        alert("Internet connection problem. Please try again.");
      } else {
        alert("Signup failed. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <img
          src="/snaptube-ghost.png"
          alt="SnapTube"
          className="auth-logo"
        />

        <h1>Create Account</h1>
        <p>Join SnapTube and start earning</p>

        <form onSubmit={signupUser}>
          <label>Full Name</label>
          <input
            type="text"
            placeholder="Enter your full name"
            value={name}
            onChange={(event) =>
              setName(event.target.value)
            }
            autoComplete="name"
            disabled={loading}
          />

          <label>Mobile Number</label>
          <input
            type="tel"
            placeholder="Enter mobile number"
            value={mobile}
            onChange={(event) =>
              setMobile(event.target.value)
            }
            autoComplete="tel"
            disabled={loading}
          />

          <label>Email Address</label>
          <input
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(event) =>
              setEmail(event.target.value)
            }
            autoComplete="email"
            disabled={loading}
          />

          <label>Password</label>
          <input
            type="password"
            placeholder="Enter password"
            value={password}
            onChange={(event) =>
              setPassword(event.target.value)
            }
            autoComplete="new-password"
            disabled={loading}
          />

          <label>Confirm Password</label>
          <input
            type="password"
            placeholder="Confirm password"
            value={confirmPassword}
            onChange={(event) =>
              setConfirmPassword(event.target.value)
            }
            autoComplete="new-password"
            disabled={loading}
          />

          <label>
            Referral Code{" "}
            <span className="optional-text">
              (Optional)
            </span>
          </label>

          <input
            type="text"
            placeholder="Enter referral code"
            value={referralCode}
            onChange={(event) =>
              setReferralCode(
                event.target.value.toUpperCase()
              )
            }
            disabled={loading}
          />

          <button
            type="submit"
            className="auth-submit-button"
            disabled={loading}
          >
            {loading
              ? "Please Wait..."
              : "Create Account"}
          </button>
        </form>

        <div className="auth-switch-text">
          Already have an account?{" "}
          <Link to="/">Login</Link>
        </div>
      </div>
    </div>
  );
}

export default Signup;